export const DEFAULT = {
  NORMAL: {
    '--standard-normal-pure-black-color': '#000000',
    '--standard-normal-pure-white-color': '#ffffff',

    '--standard-normal-primary-color': '#1c1c1c',
    '--standard-normal-secondary-color': '#333333',
    '--standard-normal-teritary-color': '#222222',

    '--standard-normal-primary-text-color': '#FFFFFF',
    '--standard-normal-secondary-text-color': 'rgba(255, 255, 255, 0.5)',
    '--standard-normal-teritary-text-color': 'var(--standard-normal-pure-black-color)',

    '--standard-normal-primary-font-family': 'var(--app-rubik-font-family)',
    '--standard-normal-secondary-font-family': 'var(--app-rubik-font-family)',
    '--standard-normal-border-color': '#444444',
    '--standard-normal-accent-color': '#71CF07',

    '--standard-normal-success-color': '#28e48a',
    '--standard-normal-success-transparent-color': '#28e4897a',
    '--standard-normal-error-color': '#ff8170',
    '--standard-normal-error-transparent-color': '#ff81707a',

    '--standard-normal-app-background-color': 'var(--standard-normal-primary-color)',

    // HEADER
    '--standard-normal-app-header-background-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-header-currency-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-header-currency-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-header-currency-font-weight': '500',
    '--standard-normal-app-header-balance-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-header-balance-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-header-balance-font-weight': '500',
    '--standard-normal-app-header-balance-positive-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-header-balance-negative-color': 'var(--standard-normal-error-color)',

    // TOGGLE (generic tokens — shared by the one Toggle component across modes)
    '--app-toggle-circle-background-color': 'var(--standard-normal-secondary-color)',
    '--app-toggle-body-before-background-color': 'var(--standard-normal-border-color)',
    '--app-toggle-body-after-background-color': 'var(--standard-normal-accent-color)',
    '--app-toggle-white-background-color': 'var(--standard-normal-pure-white-color)',

    // MENU
    '--standard-normal-app-menu-main-background-color': 'var(--standard-normal-primary-color)',
    '--standard-normal-app-menu-option-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-menu-option-font-size': 'var(--crash-game-text-sm)',
    '--standard-normal-app-menu-option-font-weight': '400',

    '--standard-normal-app-menu-navigator-title-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-menu-navigator-title-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-menu-navigator-title-font-weight': '500',

    // LAST CRASH MULTIPLIERS
    '--standard-normal-app-last-crash-multipliers-font-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-last-crash-multipliers-font-size': 'var(--crash-game-text-11)',
    '--standard-normal-app-last-crash-multipliers-font-weight': '500',
    '--standard-normal-app-last-crash-multipliers-border-radius': '5px',

    '--standard-normal-app-last-crash-multipliers-level-1-bg-color': '#BFC5CE',
    '--standard-normal-app-last-crash-multipliers-level-2-bg-color': '#6CB7FF',
    '--standard-normal-app-last-crash-multipliers-level-3-bg-color': '#58E38A',
    '--standard-normal-app-last-crash-multipliers-level-4-bg-color': '#FFD84D',
    '--standard-normal-app-last-crash-multipliers-level-5-bg-color': '#FFB05A',
    '--standard-normal-app-last-crash-multipliers-level-6-bg-color': '#FF8A80',
    '--standard-normal-app-last-crash-multipliers-level-7-bg-color': '#C9A2FF',
    '--standard-normal-app-last-crash-multipliers-level-8-bg-color': '#FFE066',

    // HOW TO PLAY  (Rocket Blast identity — blast orange)
    '--standard-normal-app-how-to-play-accent-color': '#FF6A2B',
    '--standard-normal-app-how-to-play-heading-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-how-to-play-heading-font-size': 'var(--crash-game-text-xl)',
    '--standard-normal-app-how-to-play-heading-font-weight': '700',
    '--standard-normal-app-how-to-play-body-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-how-to-play-body-font-size': 'var(--crash-game-text-13)',
    '--standard-normal-app-how-to-play-visual-bg-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-how-to-play-visual-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-how-to-play-success-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-how-to-play-error-color': 'var(--standard-normal-error-color)',
    '--standard-normal-app-how-to-play-dot-color': 'rgba(255, 255, 255, 0.14)',
    '--standard-normal-app-how-to-play-nav-bg-color': 'rgba(255, 255, 255, 0.04)',

    '--standard-normal-app-activity-panels-tab-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-activity-panels-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-activity-panels-tab-font-weight': '500',
    '--standard-normal-app-activity-panels-border-color': 'transparent',

    '--standard-normal-app-activity-panels-tab-active-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-activity-panels-active-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-activity-panels-active-tab-font-weight': '500',
    '--standard-normal-app-activity-panels-active-border-color':
      'var(--standard-normal-accent-color)',

    // Freebets menu (drawer): 3-tab segmented control + Active-tab Play button.
    '--standard-normal-app-freebets-menu-tab-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-freebets-menu-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-freebets-menu-tab-font-weight': '500',
    '--standard-normal-app-freebets-menu-active-tab-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-freebets-menu-active-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-freebets-menu-active-tab-font-weight': '500',
    '--standard-normal-app-freebets-menu-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-freebets-menu-active-border-color':
      'var(--standard-normal-accent-color)',

    '--standard-normal-app-freebets-menu-play-button-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-freebets-menu-play-button-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebets-menu-play-button-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-freebets-menu-play-button-font-weight': '600',
    '--standard-normal-app-freebets-menu-play-button-border-radius': '6px',
    '--standard-normal-app-freebets-menu-play-button-height': '24px',
    '--standard-normal-app-freebets-menu-play-button-padding': '0 10px',

    '--standard-normal-app-spinning-loader-background-color': 'var(--standard-normal-accent-color)',

    '--standard-normal-app-pagination-page-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-pagination-page-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-pagination-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-page-font-weight': '400',

    '--standard-normal-app-pagination-active-page-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-pagination-active-page-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-pagination-active-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-active-page-font-weight': '500',

    '--standard-normal-app-pagination-skip-page-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-pagination-skip-page-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-pagination-skip-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-skip-page-font-weight': '400',

    '--standard-normal-app-transactions-header-element-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-transactions-header-element-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-header-element-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-transactions-bet-card-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-transactions-bet-card-border-radius': '5px',

    '--standard-normal-app-transactions-bet-card-date-time-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-transactions-bet-card-date-time-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-date-time-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-subtype-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-transactions-bet-card-subtype-font-size': 'var(--crash-game-text-11)',
    '--standard-normal-app-transactions-bet-card-subtype-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-stake-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-transactions-bet-card-stake-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-transactions-bet-card-stake-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-won-font-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-lost-font-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-won-border-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-lost-border-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-border-radius': '20px',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-font-weight': '500',

    '--standard-normal-app-transactions-bet-card-payout-won-font-color':
      'var(--standard-normal-success-color)',

    '--standard-normal-app-transactions-bet-card-payout-lost-font-color':
      'var(--standard-normal-error-color)',
    '--standard-normal-app-transactions-bet-card-payout-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-transactions-bet-card-payout-font-weight': '400',

    '--standard-normal-app-betting-panel-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-betting-panel-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-betting-panel-header-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-betting-panel-header-tab-background-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-betting-panel-header-tab-active-background-color':
      'var(--standard-normal-secondary-color)',

    '--standard-normal-app-betting-panel-header-tab-active-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-betting-panel-header-tab-active-font-size': 'var(--crash-game-text-sm)',
    '--standard-normal-app-betting-panel-header-tab-active-font-weight': '500',

    '--standard-normal-app-betting-panel-header-tab-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-betting-panel-header-tab-font-size': 'var(--crash-game-text-sm)',
    '--standard-normal-app-betting-panel-header-tab-font-weight': '500',

    // Freebet-count badge on the Freebets tab.
    '--standard-normal-app-betting-panel-header-tab-badge-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-betting-panel-header-tab-badge-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-betting-panel-header-tab-badge-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-betting-panel-header-tab-badge-font-weight': '600',

    // Buy Bonus trigger button, in the header's extra-container slot.
    '--standard-normal-app-betting-panel-buy-bonus-button-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-betting-panel-buy-bonus-button-text-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-betting-panel-buy-bonus-button-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-betting-panel-buy-bonus-button-font-weight': '500',

    '--standard-normal-app-classic-betting-controller-divider-background-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-freebets-betting-controller-divider-background-color':
      'var(--standard-normal-border-color)',

    '--standard-normal-app-classic-betting-card-stake-module-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-classic-betting-card-stake-module-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-classic-betting-card-stake-module-border-radius': '6px',

    '--standard-normal-app-classic-betting-card-stake-module-input-font-size':
      'var(--crash-game-text-md)',
    '--standard-normal-app-classic-betting-card-stake-module-input-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-classic-betting-card-stake-module-input-font-weight': '400',

    '--standard-normal-app-classic-betting-card-stake-module-input-label-font-size':
      'var(--crash-game-text-sm)',
    '--standard-normal-app-classic-betting-card-stake-module-input-label-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-classic-betting-card-stake-module-input-label-font-weight': '400',

    '--standard-normal-app-classic-betting-card-stake-module-input-label-focus-font-size':
      'var(--crash-game-text-2xs)',
    '--standard-normal-app-classic-betting-card-stake-module-input-label-focus-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-classic-betting-card-stake-module-input-label-focus-font-weight': '400',

    '--standard-normal-app-classic-betting-card-quick-stake-module-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-classic-betting-card-quick-stake-module-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-classic-betting-card-quick-stake-module-border-radius': '6px',

    '--standard-normal-app-classic-betting-card-quick-stake-module-stake-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-classic-betting-card-stake-quick-module-stake-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-classic-betting-card-stake-quick-module-stake-font-weight': '400',

    '--standard-normal-app-classic-betting-card-extra-controls-box-title-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-title-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-title-font-weight': '400',

    '--standard-normal-app-classic-betting-card-extra-controls-box-input-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-input-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-input-border-radius': '6px',

    '--standard-normal-app-classic-betting-card-extra-controls-box-input-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-input-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-classic-betting-card-extra-controls-box-input-font-weight': '400',

    '--standard-normal-app-classic-betting-card-bet-module-bet-button-background-color':
      'var(--standard-normal-accent-color)',

    '--standard-normal-app-classic-betting-card-bet-module-bet-button-border-radius': '10px',

    '--standard-normal-app-classic-betting-card-bet-module-bet-button-title-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-classic-betting-card-bet-module-bet-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-classic-betting-card-bet-module-bet-button-title-font-weight': '500',

    '--standard-normal-app-classic-betting-card-bet-module-bet-button-desc-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-classic-betting-card-bet-module-bet-button-desc-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-classic-betting-card-bet-module-bet-button-desc-font-weight': '400',

    '--standard-normal-app-classic-betting-card-bet-module-cancel-button-background-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-classic-betting-card-bet-module-cancel-button-border-radius': '10px',

    '--standard-normal-app-classic-betting-card-bet-module-cancel-button-title-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-classic-betting-card-bet-module-cancel-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-classic-betting-card-bet-module-cancel-button-title-font-weight': '500',

    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-background-color':
      'var(--standard-normal-success-color)',

    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-border-radius': '10px',

    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-title-font-size':
      'var(--crash-game-text-sm)',
    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-title-font-weight': '500',

    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-amount-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-amount-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-classic-betting-card-bet-module-cashout-button-amount-font-weight':
      '500',

    '--standard-normal-app-freebet-betting-card-stake-module-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-freebet-betting-card-stake-module-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-freebet-betting-card-stake-module-border-radius': '6px',

    '--standard-normal-app-freebet-betting-card-stake-module-input-font-size':
      'var(--crash-game-text-md)',
    '--standard-normal-app-freebet-betting-card-stake-module-input-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-freebet-betting-card-stake-module-input-font-weight': '400',

    '--standard-normal-app-freebet-betting-card-stake-module-input-label-font-size':
      'var(--crash-game-text-2xs)',
    '--standard-normal-app-freebet-betting-card-stake-module-input-label-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-freebet-betting-card-stake-module-input-label-font-weight': '400',

    '--standard-normal-app-freebet-betting-card-expiry-time-module-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-freebet-betting-card-expiry-time-module-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-freebet-betting-card-expiry-time-module-border-radius': '6px',

    '--standard-normal-app-freebet-betting-card-expiry-time-box-font-size':
      'var(--crash-game-text-2xs)',
    '--standard-normal-app-freebet-betting-card-expiry-time-box-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-freebet-betting-card-expiry-time-box-font-weight': '500',

    '--standard-normal-app-freebet-betting-card-expiry-expired-font-color':
      'var(--standard-normal-error-color)',
    '--standard-normal-app-freebet-betting-card-expiry-expired-font-weight': '700',
    '--standard-normal-app-freebet-betting-card-expiry-expired-letter-spacing': '0.04em',

    '--standard-normal-app-freebet-betting-card-extra-controls-box-title-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-title-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-title-font-weight': '400',

    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-background-color':
      'var(--standard-normal-teritary-color)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-border-radius': '6px',

    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-freebet-betting-card-extra-controls-box-input-font-weight': '400',

    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-background-color':
      'var(--standard-normal-accent-color)',

    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-border-radius': '10px',

    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-title-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-title-font-weight': '500',

    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-desc-font-size':
      'var(--crash-game-text-xs)',
    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-desc-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebet-betting-card-bet-module-bet-button-desc-font-weight': '400',

    '--standard-normal-app-freebet-betting-card-bet-module-cancel-button-background-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-freebet-betting-card-bet-module-cancel-button-border-radius': '10px',

    '--standard-normal-app-freebet-betting-card-bet-module-cancel-button-title-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-freebet-betting-card-bet-module-cancel-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebet-betting-card-bet-module-cancel-button-title-font-weight': '500',

    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-background-color':
      'var(--standard-normal-success-color)',

    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-border-radius': '10px',

    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-title-font-size':
      'var(--crash-game-text-sm)',
    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-title-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-title-font-weight': '500',

    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-amount-font-size':
      'var(--crash-game-text-lg)',
    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-amount-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-freebet-betting-card-bet-module-cashout-button-amount-font-weight':
      '500',

    '--standard-normal-app-session-expired-overlay-background-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-session-expired-overlay-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-session-expired-overlay-divider-color':
      'var(--standard-normal-border-color)',

    '--standard-normal-app-session-expired-overlay-caution-icon-background-color':
      'var(--standard-normal-error-transparent-color)',

    '--standard-normal-app-session-expired-overlay-header-font-size': 'var(--crash-game-text-base)',
    '--standard-normal-app-session-expired-overlay-header-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-session-expired-overlay-header-font-weight': '500',

    '--standard-normal-app-session-expired-overlay-body-font-size': 'var(--crash-game-text-sm)',
    '--standard-normal-app-session-expired-overlay-body-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-session-expired-overlay-body-font-weight': '400',

    // ── Tournaments — ported 1:1 from defenderV2's _variables.scss /
    // _tournamentCard.scss / _tournamentLeaderboard.scss / _tournamentsPrizes.scss.
    // Literals are used wherever defenderV2's exact hex doesn't already match an
    // existing generic token (e.g. its "success" badge green #1e9d60 is a
    // DIFFERENT color from this theme's --standard-normal-success-color #28e48a —
    // both are real, used in different places, ported as separate tokens below).

    // Tab bar — shared shape for TournamentsMenu (Current/History) and
    // TournamentOverviewTabs (Leaderboard/Prizes/Rules); defenderV2 uses the
    // identical literal values in both of its own tab bars.
    '--standard-normal-app-tournament-tab-font-color': 'rgba(255, 255, 255, 0.6)',
    '--standard-normal-app-tournament-tab-font-size': '12px',
    '--standard-normal-app-tournament-tab-font-weight': '400',
    '--standard-normal-app-tournament-tab-active-font-color':
      'var(--standard-normal-pure-white-color)',
    '--standard-normal-app-tournament-tab-border-color': 'rgba(255, 255, 255, 0.178)',
    '--standard-normal-app-tournament-tab-indicator-color': 'var(--standard-normal-accent-color)',

    // Tournament card shell.
    '--standard-normal-app-tournament-card-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-tournament-card-top-bg-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-tournament-card-bottom-bg-color': 'var(--standard-normal-primary-color)',
    '--standard-normal-app-tournament-card-main-text-color':
      'var(--standard-normal-pure-white-color)',
    '--standard-normal-app-tournament-card-inverted-text-color':
      'var(--standard-normal-pure-black-color)',
    '--standard-normal-app-tournament-card-grayed-text-color': '#b8b8b8',

    '--standard-normal-app-tournament-card-name-font-size': '14px',
    '--standard-normal-app-tournament-card-name-font-weight': '700',
    '--standard-normal-app-tournament-card-type-font-size': '9px',
    '--standard-normal-app-tournament-card-type-font-weight': '500',

    // Status badge (list card, top-right) — bg per variant, text always inverted.
    '--standard-normal-app-tournament-card-status-font-size': '10px',
    '--standard-normal-app-tournament-card-status-font-weight': '500',
    '--standard-normal-app-tournament-card-status-active-bg-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-tournament-card-status-default-bg-color': '#359cfd',
    '--standard-normal-app-tournament-card-status-accepted-bg-color': '#1e9d60',
    '--standard-normal-app-tournament-card-status-declined-bg-color':
      'var(--standard-normal-error-color)',
    '--standard-normal-app-tournament-card-status-expired-color': 'rgba(255, 255, 255, 0.5)',

    // Digital-clock countdown boxes.
    '--standard-normal-app-tournament-card-countdown-box-bg-color':
      'var(--standard-normal-app-tournament-card-bottom-bg-color)',
    '--standard-normal-app-tournament-card-countdown-value-font-size': '10px',
    '--standard-normal-app-tournament-card-countdown-value-font-weight': '700',
    '--standard-normal-app-tournament-card-countdown-label-font-size': '8px',

    '--standard-normal-app-tournament-card-ended-font-size': '10px',
    '--standard-normal-app-tournament-card-ended-font-weight': '500',

    // Schedule row (Full Day / time range) + hover tooltip.
    '--standard-normal-app-tournament-card-schedule-font-size': '9px',
    '--standard-normal-app-tournament-card-schedule-font-weight': '600',
    '--standard-normal-app-tournament-card-schedule-font-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-tournament-card-tooltip-bg-color':
      'var(--standard-normal-pure-black-color)',
    '--standard-normal-app-tournament-card-tooltip-font-size': '10px',
    '--standard-normal-app-tournament-card-tooltip-font-weight': '500',

    // Ended-tournament rank/won row + not-opted-in quoted message.
    '--standard-normal-app-tournament-card-rankings-font-size': '12px',
    '--standard-normal-app-tournament-card-rank-value-color': 'var(--standard-normal-accent-color)',
    '--standard-normal-app-tournament-card-won-value-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-tournament-card-not-optin-font-size': '12px',
    '--standard-normal-app-tournament-card-not-optin-font-weight': '600',
    '--standard-normal-app-tournament-card-not-optin-color': 'var(--standard-normal-accent-color)',

    // Stat chips (Participants / Prize Pool / Prize|Rewards).
    '--standard-normal-app-tournament-card-stat-chip-bg-color':
      'var(--standard-normal-app-tournament-card-top-bg-color)',
    '--standard-normal-app-tournament-card-stat-chip-title-font-size': '10px',
    '--standard-normal-app-tournament-card-stat-chip-value-font-size': '11px',
    '--standard-normal-app-tournament-card-stat-chip-value-font-weight': '700',

    // Footer buttons/pills — literal per-variant colors (PRIMARY_BUTTON_CONFIG).
    '--standard-normal-app-tournament-card-footer-view-bg-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-tournament-card-footer-accept-bg-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-tournament-card-footer-decline-bg-color':
      'var(--standard-normal-error-color)',
    '--standard-normal-app-tournament-card-footer-default-bg-color': '#359cfd',
    '--standard-normal-app-tournament-card-footer-text-color':
      'var(--standard-normal-pure-black-color)',
    '--standard-normal-app-tournament-card-footer-font-weight': '500',

    // Leaderboard top-3 bars.
    '--standard-normal-app-leaderboard-bar-gold-gradient':
      'linear-gradient(to bottom, #fff200, #1c1c1c)',
    '--standard-normal-app-leaderboard-bar-silver-gradient':
      'linear-gradient(to bottom, #f7f7f7, #1c1c1c)',
    '--standard-normal-app-leaderboard-bar-bronze-gradient':
      'linear-gradient(to bottom, #ff9800, #1c1c1c)',
    '--standard-normal-app-leaderboard-bar-position-bg-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-leaderboard-bar-position-border-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-leaderboard-bar-position-me-border-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-leaderboard-bar-points-color': 'var(--standard-normal-success-color)',

    // Leaderboard/prizes table (the "others" rows + headers).
    '--standard-normal-app-tournament-table-header-color': 'rgba(255, 255, 255, 0.46)',
    '--standard-normal-app-tournament-table-header-font-size': '10px',
    '--standard-normal-app-tournament-table-row-bg-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-tournament-table-row-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-tournament-table-row-active-border-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-tournament-table-row-font-size': '12px',

    // Prizes table top-3 border colors (by DOM position, ported verbatim).
    '--standard-normal-app-prize-row-first-border-color': '#FFEA08',
    '--standard-normal-app-prize-row-second-border-color': '#DADADA',
    '--standard-normal-app-prize-row-third-border-color': '#FF7E08',
    '--standard-normal-app-prize-row-reward-color': 'var(--standard-normal-success-color)',

    '--standard-normal-app-reward-value-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-reward-value-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-reward-value-freebet-font-color': 'var(--standard-normal-success-color)',

    '--standard-normal-app-tournament-rules-title-font-size': '16px',
    '--standard-normal-app-tournament-rules-title-font-weight': '500',
    '--standard-normal-app-tournament-rules-title-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-tournament-rules-item-font-size': '12px',
    '--standard-normal-app-tournament-rules-item-font-weight': '400',
    '--standard-normal-app-tournament-rules-item-font-color':
      'var(--standard-normal-primary-text-color)',

    // ── Jackpot — ported 1:1 from defenderV2's $jackpot-* tokens
    // (_variables.scss). Reused across contexts exactly like the source does
    // (e.g. one "grayed text" / one "secondary surface" color everywhere).
    '--standard-normal-app-jackpot-grayed-text-color': '#b8b8b8',
    '--standard-normal-app-jackpot-secondary-bg-color': 'var(--standard-normal-teritary-color)',
    '--standard-normal-app-jackpot-highlight-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-jackpot-box-shadow-color': 'rgba(0, 0, 0, 0.25)',

    // Tab bar — shared shape by JackpotMenu (Active/History) and
    // JackpotOverviewTabs (Contributions/Prizes/Rules | Contributions/Results/Rules).
    '--standard-normal-app-jackpot-tab-font-color': 'rgba(255, 255, 255, 0.6)',
    '--standard-normal-app-jackpot-tab-font-size': '12px',
    '--standard-normal-app-jackpot-tab-font-weight': '400',
    '--standard-normal-app-jackpot-tab-active-font-color':
      'var(--standard-normal-pure-white-color)',
    '--standard-normal-app-jackpot-tab-border-color': 'rgba(255, 255, 255, 0.178)',
    '--standard-normal-app-jackpot-tab-indicator-color': 'var(--standard-normal-accent-color)',

    // Pill sub-tab bar (JackpotContributionsTab: Top/My Contributions).
    '--standard-normal-app-jackpot-pill-tab-bg-color': 'var(--standard-normal-primary-color)',
    '--standard-normal-app-jackpot-pill-tab-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-jackpot-pill-tab-font-size': '11px',
    '--standard-normal-app-jackpot-pill-tab-font-weight': '500',
    '--standard-normal-app-jackpot-pill-tab-indicator-color':
      'var(--standard-normal-app-jackpot-secondary-bg-color)',

    // Jackpot card (Active + History list rows).
    '--standard-normal-app-jackpot-card-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-jackpot-card-border-radius': '20px',
    '--standard-normal-app-jackpot-card-name-font-size': '15px',
    '--standard-normal-app-jackpot-card-name-font-weight': '700',
    '--standard-normal-app-jackpot-card-meta-font-size': '10px',
    '--standard-normal-app-jackpot-card-meta-font-weight': '500',
    '--standard-normal-app-jackpot-card-maturity-font-size': '11px',
    '--standard-normal-app-jackpot-card-maturity-font-weight': '700',
    '--standard-normal-app-jackpot-card-action-button-bg-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-jackpot-card-action-button-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-jackpot-card-action-button-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-jackpot-card-action-button-font-weight': '600',

    // JackpotDetail top summary.
    '--standard-normal-app-jackpot-detail-name-font-size': '18px',
    '--standard-normal-app-jackpot-detail-name-font-weight': '700',
    '--standard-normal-app-jackpot-detail-row-font-size': '12px',
    '--standard-normal-app-jackpot-detail-row-font-weight': '500',
    '--standard-normal-app-jackpot-detail-maturity-font-size': '18px',
    '--standard-normal-app-jackpot-detail-maturity-font-weight': '500',
    '--standard-normal-app-jackpot-detail-percentage-font-size': '20px',
    '--standard-normal-app-jackpot-detail-percentage-font-weight': '700',
    '--standard-normal-app-jackpot-detail-percentage-color': 'var(--standard-normal-accent-color)',
    '--standard-normal-app-jackpot-detail-bar-color': 'var(--standard-normal-accent-color)',
    '--standard-normal-app-jackpot-detail-underline-color':
      'var(--standard-normal-pure-white-color)',
    '--standard-normal-app-jackpot-detail-participation-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-jackpot-detail-total-reward-font-size': '12px',
    '--standard-normal-app-jackpot-detail-total-reward-font-weight': '700',

    // Shared table shell (Top/My Contributions, Prizes, Results).
    '--standard-normal-app-jackpot-table-header-color': '#ffffffb0',
    '--standard-normal-app-jackpot-table-header-font-size': '11px',
    '--standard-normal-app-jackpot-table-row-font-size': '12px',
    '--standard-normal-app-jackpot-table-row-me-border-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-jackpot-table-medal-gold-color': '#FFD700',
    '--standard-normal-app-jackpot-table-medal-silver-color': '#C0C0C0',
    '--standard-normal-app-jackpot-table-medal-bronze-color': '#CD7F32',

    // Rules.
    '--standard-normal-app-jackpot-rules-title-font-size': '14px',
    '--standard-normal-app-jackpot-rules-title-font-weight': '700',
    '--standard-normal-app-jackpot-rules-item-font-size': '12px',
    '--standard-normal-app-jackpot-rules-item-font-weight': '500',

    // Ticket screens (JackpotTicketsScreen / JackpotBetTicketsScreen).
    '--standard-normal-app-jackpot-ticket-chip-bg-color':
      'var(--standard-normal-app-jackpot-secondary-bg-color)',
    '--standard-normal-app-jackpot-ticket-meta-color': '#ffffff9f',
    '--standard-normal-app-jackpot-ticket-selected-border-color':
      'var(--standard-normal-accent-color)',

    // Header JackpotBar — defenderV2 uses a distinct literal gold here (not
    // the app's green accent), on purpose, for both the header widget and the
    // main-layout ratio message text.
    '--standard-normal-app-jackpot-bar-gold-color': '#ffd700',
    '--standard-normal-app-jackpot-bar-track-bg-color': 'rgba(30, 30, 50, 0.8)',
    '--standard-normal-app-jackpot-bar-text-font-size': '10px',
    '--standard-normal-app-jackpot-bar-text-font-weight': '600',
    '--standard-normal-app-jackpot-ratio-message-font-size': '11px',
    '--standard-normal-app-jackpot-ratio-message-font-color':
      'var(--standard-normal-app-jackpot-bar-gold-color)',

    // ── Buy Bonus — ported 1:1 from defenderV2's $buy-freebets-* tokens
    // (_variables.scss). Modal card triggered from the betting panel header.
    '--standard-normal-app-buy-bonus-overlay-background-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-buy-bonus-overlay-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-buy-bonus-invert-font-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-buy-bonus-grayed-text-color': '#b8b8b8',
    '--standard-normal-app-buy-bonus-buy-button-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-buy-bonus-buy-button-text-color':
      'var(--standard-normal-teritary-text-color)',
    '--standard-normal-app-buy-bonus-header-font-size': '14px',
    '--standard-normal-app-buy-bonus-header-font-weight': '700',

    // Package card — outer chip/title use the accent color, the inner details
    // box uses the dark primary surface (defenderV2's primary/secondary split).
    '--standard-normal-app-buy-bonus-package-item-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-buy-bonus-package-item-inner-background-color':
      'var(--standard-normal-primary-color)',
  },
  MINI: {
    '--standard-mini-pure-black-color': '#000000',
    '--standard-mini-pure-white-color': '#ffffff',

    '--standard-mini-primary-color': '#222222',
    '--standard-mini-secondary-color': '#333333',
    '--standard-mini-tertiary-color': '#1c1c1c',

    '--standard-mini-primary-text-color': '#ffffff',
    '--standard-mini-secondary-text-color': '#A0A0A0',

    '--standard-mini-border-color': '#444444',

    '--standard-mini-accent-color': '#71cf07',

    '--standard-mini-success-color': '#28e48a',
    '--standard-mini-error-color': '#ff5470',

    '--standard-mini-font-family': 'var(--app-rubik-font-family)',

    '--standard-mini-app-background-color': 'var(--standard-mini-primary-color)',

    // TOGGLE (same generic tokens as NORMAL, mapped to the mini palette)
    '--app-toggle-circle-background-color': 'var(--standard-mini-secondary-color)',
    '--app-toggle-body-before-background-color': 'var(--standard-mini-border-color)',
    '--app-toggle-body-after-background-color': 'var(--standard-mini-accent-color)',
    '--app-toggle-white-background-color': 'var(--standard-mini-pure-white-color)',

    // HEADER
    '--standard-mini-app-header-icon-ring-color': 'var(--standard-mini-accent-color)',
    '--standard-mini-app-header-title-font-color': 'var(--standard-mini-primary-text-color)',
    '--standard-mini-app-header-title-font-size': 'var(--crash-game-text-xs)',
    '--standard-mini-app-header-title-font-weight': '700',
    '--standard-mini-app-header-tagline-font-color': 'var(--standard-mini-secondary-text-color)',
    '--standard-mini-app-header-tagline-font-size': 'var(--crash-game-text-2xs)',
    '--standard-mini-app-header-balance-label-font-color':
      'var(--standard-mini-secondary-text-color)',
    '--standard-mini-app-header-balance-label-font-size': 'var(--crash-game-text-2xs)',
    '--standard-mini-app-header-balance-font-color': 'var(--standard-mini-primary-text-color)',
    '--standard-mini-app-header-balance-font-size': 'var(--crash-game-text-xs)',
    '--standard-mini-app-header-balance-font-weight': '700',

    // BET CARD
    '--standard-mini-app-betcard-label-font-color': 'var(--standard-mini-secondary-text-color)',
    '--standard-mini-app-betcard-label-font-size': 'var(--crash-game-text-xs)',

    '--standard-mini-app-betcard-preset-background-color': 'var(--standard-mini-secondary-color)',
    '--standard-mini-app-betcard-preset-border-color': 'var(--standard-mini-border-color)',
    '--standard-mini-app-betcard-preset-font-color': 'var(--standard-mini-primary-text-color)',
    '--standard-mini-app-betcard-preset-font-size': 'var(--crash-game-text-13)',
    '--standard-mini-app-betcard-preset-border-radius': '8px',

    '--standard-mini-app-betcard-input-background-color': 'var(--standard-mini-tertiary-color)',
    '--standard-mini-app-betcard-input-border-color': 'var(--standard-mini-border-color)',
    '--standard-mini-app-betcard-input-focus-border-color': 'var(--standard-mini-accent-color)',
    '--standard-mini-app-betcard-input-font-color': 'var(--standard-mini-primary-text-color)',
    '--standard-mini-app-betcard-input-font-size': 'var(--crash-game-text-13)',
    '--standard-mini-app-betcard-input-border-radius': '8px',

    '--standard-mini-app-betcard-bet-button-background-color': 'var(--standard-mini-accent-color)',
    '--standard-mini-app-betcard-cashout-button-background-color':
      'var(--standard-mini-success-color)',
    '--standard-mini-app-betcard-cancel-button-background-color':
      'var(--standard-mini-error-color)',
    '--standard-mini-app-betcard-action-button-font-color': 'var(--standard-mini-tertiary-color)',
    '--standard-mini-app-betcard-action-button-title-font-size': 'var(--crash-game-text-lg)',
    '--standard-mini-app-betcard-action-button-amount-font-size': 'var(--crash-game-text-sm)',
    '--standard-mini-app-betcard-action-button-border-radius': '10px',

    // RECENT RESULTS (label + text-coloured multipliers)
    '--standard-mini-app-recent-results-label-font-color':
      'var(--standard-mini-secondary-text-color)',
    '--standard-mini-app-recent-results-label-font-size': 'var(--crash-game-text-xs)',
    '--standard-mini-app-last-crash-multipliers-font-size': 'var(--crash-game-text-xs)',
    '--standard-mini-app-last-crash-multipliers-font-weight': '500',
    '--standard-mini-app-last-crash-multipliers-level-1-color': '#bfc5ce',
    '--standard-mini-app-last-crash-multipliers-level-2-color': '#6cb7ff',
    '--standard-mini-app-last-crash-multipliers-level-3-color': '#58e38a',
    '--standard-mini-app-last-crash-multipliers-level-4-color': '#ffd84d',
    '--standard-mini-app-last-crash-multipliers-level-5-color': '#ffb05a',
    '--standard-mini-app-last-crash-multipliers-level-6-color': '#ff8a80',
    '--standard-mini-app-last-crash-multipliers-level-7-color': '#c9a2ff',
    '--standard-mini-app-last-crash-multipliers-level-8-color': '#ffe066',
  },
}
